window.CheckMapaImagenes = () => {
  document.querySelectorAll(".imagen-placeholder").forEach((contImg) => {
    let img = contImg.querySelector("img")
    if(img != null){
      img.onerror = function() {
        contImg.classList.add("img-error")
      };
    }
  })
}
window.ReportErrorLog = (error) => {
  let errorStr = `${location.href} - ${error.name}: ${error.message}\n${error.stack}`
  axios.post("/reportar-error-log", {
    error: errorStr
  })
    .then((respuesta) => {}).catch((error) => {})
}

window.addEventListener('error', function (event) {
  // Ignoramos los errores JavaScript normales ya capturados por `window.onerror`.
  console.log("error")
  if (event.target !== window) {
    const errorData = {
      type: 'Resource Error',
      tagName: event.target.tagName,
      source: event.target.src || event.target.href,
    };

    ReportErrorLog(errorData);
  }
}, true);

window.addEventListener('unhandledrejection', function (event) {
  console.log("unhandledrejection")
  const errorData = {
    type: 'Unhandled Promise Rejection',
    message: event.reason?.message || event.reason,
    stack: event.reason?.stack || '',
  };

  ReportErrorLog(errorData);
});

$(document).ready(function () {

  window.iniciarPasswordToggle = () => {
    $(".btn-toggle-password").click((e) => {
      let $btn = $(e.target)
      let $parent = $btn.parent()
      if($parent.hasClass("btn-toggle-password")){
        $parent = $parent.parent()
      }
      let $input = $parent.find(".input-password")
      if($input.attr("type") == "password"){
        $input.attr("type", "text")
      }
      else{
        $input.attr("type", "password")
      }
    })
  }

  iniciarPasswordToggle();

  if ($(window).scrollTop() > 150) {
    $('#header').addClass('sticky')
  }
  $(window).scroll(function () {
    if ($(this).scrollTop() > 150) {
      $('#header').addClass('sticky')
    } else {
      $('#header').removeClass('sticky')
    }
  })

  window.desactivarInputScroll = ($form) => {
    $form.on('focus', 'input[type=number]', function (e) {
      $(this).on('wheel.disableScroll', function (e) {
        e.preventDefault()
      })
    })
    $form.on('blur', 'input[type=number]', function (e) {
      $(this).off('wheel.disableScroll')
    })
  }


  $('body').on('show.bs.modal', function (e) {
    setTimeout(() => {
      $("header").css("padding-right", $("body").css("padding-right"))
    }, 100)
  });
  $('body').on('hidden.bs.modal', function () {
    $("header").css("padding-right", 0)
  });

  $(".publica-terraza").click((e) => {
    if ($(e.target).attr("href") == "#") {
      e.preventDefault()
      $("#formLogin")[0].dataset.url = "/publica-tu-terraza";
      $("#modalLogIn").modal("show")
    }
  })

  $(".pick-imagen").change(e => {
    let $input = $(e.target)
    let [imagen] = e.target.files
    if (imagen != null) {
      let $img = $input.parent().find("img")
      $img.attr("src", URL.createObjectURL(imagen))
    }
  });

});

$(document).ready(function(){
  $('[data-toggle="tooltip"]').tooltip();
});
